export default __webpack_public_path__ + "static/media/smiley1-filled.cbe8d3d6.svg";